module.exports = __webpack_public_path__ + "static/img/page404.2c8696c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page404.png
// module id = E9RA
// module chunks = 0